<template>
  <div>
    <div class="row border-bottom white-bg dashboard-header">
      <div class="col-lg-12">
        <h1>Scheduled Posts</h1>
      </div>
    </div>
    <div class="dashboard-container">
      <div class="row">
        <div class="col-md-4">
          <scheduled-post-list
            :channels="socialChannels"
            :posts="scheduledMessages"
            @newPost="onAddNewPost"
            @editPost="onEditPost"
            @deletePost="onDeleteScheduledPost"
          />
        </div>
        <div class="col-md-8">
          <social-post-calendar
            :channels="socialChannels"
            :posts="scheduledMessages"
            @newPost="onAddNewPost"
            @editPost="onEditPost"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapGetters } from 'vuex';
import ScheduledPostList from '@/components/social/ScheduledPostList';
import SocialPostCalendar from '@/components/social/SocialPostCalendar';

export default {
  name: 'SocialScheduleDashboard',
  components: {
    ScheduledPostList,
    SocialPostCalendar,
  },
  computed: {
    ...mapState('social', ['scheduledMessages']),
    ...mapGetters('channel', ['socialChannels']),
  },
  mounted() {
    this.$store.dispatch('social/getScheduledMessages');
    this.$store.dispatch('channel/getChannels');
  },
  methods: {
    onAddNewPost(date) {
      let post = null;
      if (date) {
        post = {
          channels: [],
          company: null,
          id: null,
          media: [],
          message: '',
          post_date: moment(date).format('YYYY-MM-DDTHH:mm:ss'),
        };
      }
      this.$store.dispatch('modals/showSocialPostDialog', post);
    },

    onEditPost(post) {
      this.$store.dispatch('modals/showSocialPostDialog', post);
    },

    onDeleteScheduledPost(id) {
      this.$store
        .dispatch('social/deleteScheduledPost', id)
        .then(() => this.$store.dispatch('social/getScheduledMessages'));
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-container {
  margin: 15px;
}
</style>


// WEBPACK FOOTER //
// SocialScheduleDashboard.vue?1cbd2b8b